// Lightweight chat alert sound + haptic. No asset file — uses Web Audio
// API to synthesize a soft two-note chime. Honors a persisted mute flag
// in localStorage and the page-visibility state (silent when backgrounded;
// the OS handles backgrounded notifications via push later).

import { tapLight } from './haptics';

const STORAGE_KEY = 'pnp_chat_alerts_muted';

export const isChatAlertsMuted = () => {
  try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
};

export const setChatAlertsMuted = (muted) => {
  try {
    if (muted) localStorage.setItem(STORAGE_KEY, '1');
    else localStorage.removeItem(STORAGE_KEY);
  } catch { /* ignore */ }
};

let audioCtx = null;
const getCtx = () => {
  if (audioCtx) return audioCtx;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  audioCtx = new Ctx();
  return audioCtx;
};

// Soft "ding" — two short tones, decay envelope, low volume.
const playChime = () => {
  const ctx = getCtx();
  if (!ctx) return;
  // Resume if the autoplay policy suspended it (no-op if already running)
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});

  const now = ctx.currentTime;
  const tones = [
    { freq: 880, start: 0,    dur: 0.18, gain: 0.08 }, // A5
    { freq: 1175, start: 0.09, dur: 0.22, gain: 0.06 }, // D6
  ];

  tones.forEach(({ freq, start, dur, gain }) => {
    const osc = ctx.createOscillator();
    const env = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    env.gain.value = 0;
    env.gain.setValueAtTime(0, now + start);
    env.gain.linearRampToValueAtTime(gain, now + start + 0.02);
    env.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
    osc.connect(env).connect(ctx.destination);
    osc.start(now + start);
    osc.stop(now + start + dur + 0.02);
  });
};

export const playChatAlert = () => {
  if (isChatAlertsMuted()) return;
  if (typeof document !== 'undefined' && document.hidden) return;
  try { playChime(); } catch { /* ignore */ }
  tapLight();
};
